import { logger } from '@/lib/logger';

/** dist直下に出力されるビルド識別子ファイルの形（vite.config.tsのbuildIdManifestPluginが書き出す） */
interface VersionManifest {
  buildId: string;
}

/**
 * version.jsonを取得してビルド識別子を返す。
 * ネットワーク断・JSON不正・非200は「新版なし」の判断に使えるよう、例外を投げずnullを返す。
 * 呼び出し側でユーザーへの通知を諦める（ADR-0011）。
 */
export async function fetchLatestBuildId(
  fetchFn: typeof fetch = fetch
): Promise<string | null> {
  try {
    const response = await fetchFn('/version.json', { cache: 'no-store' });
    if (!response.ok) {
      logger.warn('version.jsonの取得に失敗しました', { status: response.status });
      return null;
    }
    const data = (await response.json()) as VersionManifest;
    if (typeof data?.buildId !== 'string' || data.buildId.length === 0) {
      logger.warn('version.jsonの形式が不正です');
      return null;
    }
    return data.buildId;
  } catch (error) {
    logger.warn('version.jsonの取得中にエラーが発生しました', {
      error: (error as Error).message,
    });
    return null;
  }
}

/**
 * 取得したビルド識別子が、実行中のビルドと異なるかを判定する。
 * 取得できなかった場合（null）は「新版なし」として扱う。
 */
export function isNewBuildAvailable(
  currentBuildId: string,
  latestBuildId: string | null
): boolean {
  if (latestBuildId === null) {
    return false;
  }
  return latestBuildId !== currentBuildId;
}
